import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  getTrainingStartStatus,
  getUserWiseTraining,
} from "../../../actions/learning_provider/provider_user/training_action";
import AppBody from "../../components/AppBody";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { UI_URL } from "../../../config/api";

const UserWiseTraining = () => {
  const state = useSelector((state) => state.puTrainingReducer);
  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [redirect, setredirect] = useState(false);
  const [details, setDetails] = useState({
    slug: "",
    name: "",
  });
  const [trainingName, setTrainingName] = useState("");
  useEffect(() => {
    dispatch(getUserWiseTraining());
  }, []);

  if (!localStorage.getItem("token")) {
    localStorage.setItem("redirectLink", location.pathname);
  }

  const handelStartMeetingClick = (slug, name) => {
    setDetails({
      slug: slug,
      name: name,
    });
    dispatch(getTrainingStartStatus({ slug: slug }));
    //navigate("/conference/" + slug);
    // let isTraining = localStorage.getItem("is_training");
    // if (!isTraining) {
    //   setTrainingName(name);
    //   setredirect(false);
    //   setDetails({
    //     slug: slug,
    //     name: name,
    //   });

    // }
  };

  if (state.trainingStatus === 0 && !open && !state.loading && details.name) {
    setOpen(true);
  } else {
    if (state.trainingStatus === 1) {
      window.open(UI_URL + "/conference/" + details.slug);
    }
  }

  // if (trainingName && !open && state.trainingStatus === 0 && !state.loading) {
  //   //navigate("/conference/" + details.slug);
  //   setOpen(true);
  // } else {

  //   let isTraining = localStorage.getItem("is_training");
  //   let trCount = localStorage.getItem("trCount");
  //  if (!trCount && !isTraining && !redirect && state.trainingStatus === 1) {
  //     //window.open(UI_URL + "/training/" + details.slug);
  //     localStorage.setItem("trCount", 1);
  //     setredirect(true);
  //     setOpen(false);
  //     setTrainingName("");
  //    // navigate("/conference/" + details.slug);
  //   }

  //  // navigate("/conference/" + details.slug);
  // }
  const handleClose = () => {
    setOpen(false);
    setDetails({
      name: "",
    });
  };

  if (location.pathname === "/my-trainings/") {
    setTimeout(() => {
      window.close("/my-trainings/");
    }, 2000);
  }
  const navigate = useNavigate();
  const viewCertificate = (slug) => {
    navigate("/certificate/" + slug);
  };

  const viewDetails = (slug) => {
    navigate("/user/training-details/" + slug);
  };
  
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 shadow-xs p-0 mb-4">
            <div className="card-header p-4 w-100 border-0 d-flex rounded-lg">
              <h4 className="font-xs text-white fw-600  mb-0 mt-2">
                My Trainings
              </h4>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      {/* <th>Join</th>*/}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.name}</td>
                          <td>{li.start_date}</td>
                          <td>{li.end_date}</td>
                          {/* <td>{li.join === 1 ? "YES" : "NO"}</td>*/}
                          <td>
                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Start"
                              target="_blank"
                              onClick={() => {
                                li.totalTopics > 0
                                  ? viewDetails(li.slug)
                                  : handelStartMeetingClick(li.slug, li.name);
                              }}
                            >
                              <i className="feather-play-circle"></i>
                            </a>

                            {li.is_download_certificate === 1 && (
                              <a
                                className="line-height-36 custom-icon mr-2"
                                title="Certificate"
                                target="_blank"
                                onClick={() => viewCertificate(li.slug)}
                              >
                                <i className="fa fa-certificate"></i>
                              </a>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <Modal show={open} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title
                className={"color-white"}
                style={{ color: "aliceblue", fontWeight: 700 }}
              >
                {trainingName}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="err-model-body">
              <div className="form-group">
                <label className="mont-font fw-600 font-xsss color-white">
                  Waiting for the host to start the training, please standby !
                </label>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button className="tr-popup-btn" onClick={() => handleClose()}>
                Close
              </button>
              <button
                className="tr-popup-btn"
                onClick={() =>
                  handelStartMeetingClick(details.slug, details.name)
                }
              >
                Join Again
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      }
    />
  );
};

export default UserWiseTraining;
